import IconButton from '@mui/material/IconButton'
import { forwardRef } from 'react'
import PriaSvgErrorIcon from '../assets/pria-error-icon.svg'
import PriaSvgIcon from '../assets/pria-icon.svg'

export const PriaIconButton = forwardRef(({ onClick = () => {}, isLoading = false, style = {}, disabled = false, error = false, ...rest }, ref) => {
  return (
      <IconButton
        ref={ref}
        onClick={onClick}
        disabled={disabled}
        sx={{
          boxShadow: error ? '0px 0px 13px 0px rgba(255, 0, 0, 0.35)' : '0px 0px 13px 0px rgba(0, 21, 41, 0.20)',
          filter: disabled ? 'opacity(60%)' : undefined,
          position: 'absolute',
          bottom: 24,
          right: 24,
          border: '0.5px solid var(--Azul-Secundrio-1, #013995);',
          ...style
        }}
        {...rest}
      >
        <img src={error ? PriaSvgErrorIcon : PriaSvgIcon} id='dsar-pria' style={{ width: 40, height: 40 }} />
      </IconButton>
  )
})

PriaIconButton.displayName = 'PriaIconButton'
